<template lang="pug">
  betList(betType="CS")
</template>

<script>
import betList from "@/views/stock/_betList.vue";

export default {
  components: {
    betList
  }
};
</script>